<template>
  <div>
    <baseEdit />
  </div>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'logisticsContractAdd',
    components: {
      baseEdit,
    },
  };
</script>
